import { Resource } from "i18next"

const en: Resource = {
    translation: {
        'Help': 'Ayuda',
        'Sign In': 'Inicio de Sesión',
        'powered by ALNUS SpA': 'OIRS Contigo: {{brand}}',
        'Complete your login info.': 'Completa tu información de inicio de sesión para ingresar a tu espacio privado.',
        'Copyright': '© {{ year }} ALNUS SpA.',
        'Email address': 'Correo electrónico',
        'Enter your email address': 'Ingresa tu correo electrónico',
        'Password': 'Contraseña',
        'Enter your password': 'Ingresa tu contraseña',
        'Authorize this device': 'Autoriza este dispositivo',
        'Lost your password?': '¿Olvidaste tu contraseña?',
        'Login': 'Iniciar Sesión',
        'The data will be transferred through a secure SSL encrypted connection.': 'Los datos serán transferidos mediante una conexión segura.',
        'Terms': 'Términos y Condiciones',
        'Privacy': 'Política de Privacidad',
        'Contact us': 'Contáctanos',
        'Recover your password': 'Recupera tu contraseña',
        'Complete your email to request a new password': 'Completa tu correo electrónico y haz clic en el botón recuperar, para enviar una solicitud de recuperación.',
        'Recover password': 'Recuperar',
        'Back to login': 'Volver a iniciar sesión',
        'Shortcuts': 'Atajos',
        'Configure your shortcuts': 'Configura tus atajos',
        'Your identity card number': 'RUT',
        'Enter your id': 'Ingresa tu RUT',
        /** Permissions details */
        'titlepatient': 'Módulo de Pacientes',
        'patienttrace' : 'Seguimiento de un paciente',
        'patientlist' : 'Listar todos los pacientes', 
        'patientget' : 'Visualizar un paciente',
        'patientedit' : 'Editar un paciente', 
        'patientadd' : 'Registar nuevo paciente', 
        'titleactivity': 'Módulo de Actividades',
        'activityprint': 'Imprimir actividad',
        'activityscan': 'Escaneo de Pase de Visita',
        'activityedit': 'Editar actividad',
        'activityadd': 'Registrar nueva actividad',
        'activityview': 'Visualizar actividad',
        'titlecapacity': 'Módulo de Capacidad',
        'capacitycensus': 'Censo de Pacientes',

    }
}

export default en